var React = require('react');

function ArrowRight40 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M2.24805 14.3984L43.9999 14.3984","stroke":"#6335CC","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M31 1.5249L43.6318 14.3909","stroke":"#6335CC","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M31 27.272L43.6318 14.3909","stroke":"#6335CC","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":2})]);
}

ArrowRight40.defaultProps = {"width":"46","height":"29","viewBox":"0 0 46 29","fill":"none"};

module.exports = ArrowRight40;

ArrowRight40.default = ArrowRight40;
